import script from "./Occupancy.vue?vue&type=script&setup=true&lang=js"
export * from "./Occupancy.vue?vue&type=script&setup=true&lang=js"

import "./Occupancy.vue?vue&type=style&index=0&id=88da1aec&lang=css"

const __exports__ = script;

export default __exports__